import * as React from "react";
const SvgFiRrPenField = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.75 9.693A5 5 0 0 1 24 13.001v5c0 2.756-2.243 5-5 5H5c-2.757 0-5-2.244-5-5v-5c0-2.758 2.243-5 5-5h4a1 1 0 1 1 0 2H5c-1.654 0-3 1.346-3 3v5c0 1.653 1.346 3 3 3h14c1.654 0 3-1.347 3-3v-5a3 3 0 0 0-.75-1.984 1 1 0 0 1 1.5-1.324M5 15.501a1.5 1.5 0 1 0 3.001-.002A1.5 1.5 0 0 0 5 15.501m6.5 1.5a1.5 1.5 0 1 0-.001-3.002A1.5 1.5 0 0 0 11.5 17m.5-6V9.414c0-1.068.416-2.073 1.172-2.828L18.879.88A3.002 3.002 0 0 1 24 3c0 .801-.313 1.555-.879 2.122l-5.707 5.708a3.98 3.98 0 0 1-2.828 1.172H13a1 1 0 0 1-1-1zm2-1h.586c.534 0 1.036-.209 1.414-.587l5.707-5.707A1 1 0 0 0 22 3a1 1 0 0 0-1.707-.707L14.586 8A2.02 2.02 0 0 0 14 9.414z"
    />
  </svg>
);
export default SvgFiRrPenField;
